/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addCustomerSpecificReferenceableSyncEntity} from '../api'

export const useMutationAddCustomerSpecificReferenceableSyncEntity = createReactQueryMutationHook('addCustomerSpecificReferenceableSyncEntity', addCustomerSpecificReferenceableSyncEntity)
